<evc-leftbar id="fake-bar" [leftbarConfig]="leftBarMenu" class="left-bar" (isOpenChange)="leftBarIsOpenChange($event)">
    <evc-nav-button type="cta" variant="round" size="xxl" (click)="createReport()" top-cta [disabled]="!inspection || inspectionImagesCount < 1 || isReadOnly || isDeletedInspection">
        <span class="top-cta-label" *ngIf="isLeftBarOpened">
            {{"inspection.report" | translate}}
        </span>
        <evc-svg-icon size="md" [icon]=plusIcon></evc-svg-icon>
    </evc-nav-button>

    <div *ngIf="isLeftBarOpened"  class="opened-side-nav-contents" leftbar-bottom-content>

        <ul class="sidenav-tab" fxLayout="row">
            <li (click)="changeSidenav(sidenavTypes[0])" [class.disabled]="isDeletedInspection"
                [class.selected]="this.sideNavType === sidenavTypes[0]" class="tab-style">
                {{ 'inspection.folder' | translate }}
            </li>
            <li (click)="changeSidenav(sidenavTypes[1])" [class.selected]="this.sideNavType === sidenavTypes[1]"
                class="tab-style">
                {{ 'inspection.report' | translate }}
            </li>
        </ul>
        <ng-container [ngSwitch]="this.sideNavType">
            <ng-container *ngSwitchCase="sidenavTypes[0]">
                <app-location-folder-tab (imageUpload)="upload()" *ngIf="subjectModel"
                                         (updateInspection)="updateInspectionEmit($event)"
                                         [inspection]="inspection"
                                         [isReadOnly]="isReadOnly"
                                         [subjectModel]="subjectModel">
                </app-location-folder-tab>
            </ng-container>

            <ng-container *ngSwitchCase="sidenavTypes[1]">
                <app-inspection-report-tab [generatedReports]="generatedReportTree"
                                           [historyReports]="historyReports"
                                           [inspectionReport]="report"
                                           [isDeletedInspection]="isDeletedInspection"
                                           [isReportLoading]="isReportLoading"
                                           [selectedFilter]="pastReportFilter"
                                           [subjects]="subjects4Inspections"
                                           data-testid="report-tab-content"
                                           >
                </app-inspection-report-tab>
            </ng-container>
        </ng-container>
    </div>

</evc-leftbar>



